import { Phone, Mail, MapPin} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const services = [
    'Ofis Temizliği',
    'Tadilat Sonrası Temizlik',
    'Yangın Sonrası Temizlik',
    'Dış Cephe & Cam Temizliği'
  ];

  return (
    <footer id="iletisim" className="bg-gray-900 text-gray-300 py-16">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-12">
          {/* Logo and About */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <span className="text-3xl font-bold text-white">BEKTAŞ</span>
              <span className="text-3xl font-bold text-blue-500">TEMİZLİK</span>
            </div>
           
            <p className="text-gray-400 text-sm leading-relaxed">
              2007'den beri İstanbul'da profesyonel temizlik hizmetleri sunmaktayız. 
              Müşteri memnuniyetini ön planda tutarak, hijyen standartlarında hizmet veriyoruz.
            </p>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-white">Hizmetlerimiz</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <a 
                    href="#hizmetler" 
                    className="text-gray-400 hover:text-white transition-colors text-sm flex items-center"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-white">İletişim</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 mt-0.5 text-blue-400 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium">Telefon</p>
                  <a href="tel:+902126553821" className="text-gray-400 hover:text-white transition-colors block">
                    (212) 655 38 21
                  </a>
                  <a href="tel:+905327385437" className="text-gray-400 hover:text-white transition-colors block mt-1">
                    0532 738 54 37
                  </a>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 mt-0.5 text-blue-400 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium">E-posta</p>
                  <a href="mailto:info@bektastemizlik.com" className="text-gray-400 hover:text-white transition-colors">
                    info@bektastemizlik.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-0.5 text-blue-400 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium">Adres</p>
                  <address className="text-gray-400 not-italic">
                    Kocasinan Mh. Bağcılar Karayolu Cad.<br />
                    Dostlar Ap. No:34-14<br />
                    Bahçelievler/İstanbul Türkiye
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 pb-2 px-4 flex justify-between items-center">
          <p className="text-sm text-gray-500">
            © {currentYear} Bektaş Temizlik ve Pazarlama Ltd. Tüm hakları saklıdır.
          </p>
          <a 
            href="https://goldlink.com.tr" 
            rel="nofollow"
            className="text-xs font-bold text-gray-400 hover:text-white transition-colors"
          >
            By GoldLink
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;